import { addModal } from 'Redux/modules/modal/actions';
import React from 'react';
import { CONSULT_TOO_SHORT_MINUTES } from 'Containers/Teleconsult/Main/constants';

export const showModalConsultTooShort = ({ handleOnOk }) =>
  addModal({
    type: 'warningModal',
    id: 'consult-too-short',
    data: {
      content: (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div style={{ fontSize: '20px', fontWeight: 'bold' }}>Finish Consult</div>
          <div style={{ padding: '8px 0', fontSize: '16px' }}>
            <p>
              Video Consult duration seems inadequate.
              <br />
              Press “Finish Consult” if you still wish to proceed to end this consultation.
            </p>
          </div>
        </div>
      ),
      size: 'tiny',
      onOk: async () => handleOnOk(),
      okText: 'Finish Consult',
      onClose: () => undefined,
    },
  });

export const isDurationTooShort = duration => duration < CONSULT_TOO_SHORT_MINUTES * 60;
